import { Link } from 'react-router-dom';
import { ForgotPasswordForm } from '../../components/auth';
import { AuthLayout } from '../../components/layouts';

export function ForgotPasswordPage() {
  return (
    <AuthLayout
      title="Reset your password"
      subtitle={
        <>
          Remember your password?{' '}
          <Link to="/login">Log in</Link>
        </>
      }
    >
      <ForgotPasswordForm />
    </AuthLayout>
  );
}
